import { Typography } from '@mui/material';
import { AppImages } from 'assets/appResources';
import { GlobalClassKeys } from 'assets/jss/common-styles';
import { GridEx } from 'components/MuiExtras/Grid/GridEx';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiDanger from 'components/MuiExtras/Typography/MuiDanger';
import VideoPlayer, { stopAnothersVideoPlayers } from 'components/VideoPlayer';
import { Formaters } from 'lib/Formarters';
import { FileGetDto } from 'models/ApiModels';
import queryString from 'query-string';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { RenderVideoType } from 'views/Publication/Components/RenderVideo';
import { VideoPlayerSearchApi } from 'views/Publication/Components/RenderVideo/RenderVideoCommon';
import { stopAnothersYoutubes } from 'views/Publication/Components/RenderVideo/RenderYoutube';
import { VideoSearchBox } from 'views/Publication/Components/RenderVideo/SearchBox';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function getBounderies(width: number, height: number) {
    const fontSize = Number(window.getComputedStyle(document.body).getPropertyValue('font-size').match(/\d+/)[0]);

    if (width && height) {

        var w, h;

        if (width / height >= (4.0 / 3.0)) {
            // 16 x 9
            w = width > 640 ? 640 : width;
            h = height * (w / width);
        }
        else {
            // 4 x 3
            const maxH = fontSize * 22.5;
            h = height > maxH ? maxH : height;
            w = width * (h / height);
        }

        return { width: w, height: h };
    }

    return { width, height };
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const RenderVideoWaitingEncode: React.FC<{ attach: FileGetDto; }> = (props) => {
    const { attach } = props;
    const { t } = useTranslation();
    return (
        <MuiContainer>
            <GridEx container direction="row">
                <GridEx item>
                    <img
                        src={AppImages.VideoEncoding}
                        width={128}
                        height={128}
                        title={t("Views.Publication.Components.RenderVideo.VideoProcessingTitle")}
                        alt={t("Views.Publication.Components.RenderVideo.VideoProcessingTitle")}
                    />
                </GridEx>
                <GridEx item xs>
                    <GridEx container justifyContent="space-between">
                        <GridEx item direction="column">
                            <Typography variant="body2"><MuiDanger>{t("Views.Publication.Components.RenderVideo.VideoProcessingMessage")}</MuiDanger></Typography>
                        </GridEx>
                        {
                            attach.metadata?.duration &&
                            <GridEx item>
                                <Typography variant="body1">{Formaters.ticksToDurationString(attach.metadata.duration)}</Typography>
                            </GridEx>
                        }
                    </GridEx>
                </GridEx>
            </GridEx>
        </MuiContainer>
    );
};

export function getRenderVideoStyles(attach: FileGetDto) {
    var outerStyles = {};
    var innerStyles = {};
    if (attach.metadata && attach.metadata.width && attach.metadata.height) {
        var bounderies = getBounderies(attach.metadata.width, attach.metadata.height);
        outerStyles = { display: "flex", justifyContent: "center" };
        innerStyles = { height: bounderies.height, width: bounderies.width };
    }

    return {
        outerStyles,
        innerStyles,
    };
}

export function getVideoProps(attach: FileGetDto) {
    const uniqueId: number = new Date().getTime();
    const sources = Array<any>();

    if (attach.mediaAsset != null) {
        if (attach.mediaAsset.hlsUri != null) {
            sources.push({ type: "application/x-mpegurl", src: attach.mediaAsset.hlsUri });
        }
        else if (attach.mediaAsset.progressiveDownloadUris != null) {
            attach.mediaAsset.progressiveDownloadUris.forEach((v) => {
                sources.push({ type: "video/mp4", src: v });
            });
        }
    }

    if (sources.length == 0 && attach.mimeType == "video/mp4") {
        sources.push({ type: attach.mimeType, src: attach.url });
    }

    return {
        playerId: "vp_" + attach.fileId + "_" + uniqueId,
        poster: attach.mediaAsset != null ? attach.mediaAsset.posterUrl : AppImages.PlayVideo,
        sources
    };
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface RenderVideoState {
}

class RenderVideoFile extends React.Component<RenderVideoType, RenderVideoState> {
    private qs: string = null;

    constructor(props: RenderVideoType) {
        super(props);
        this.state = { playing: false };
        const q = queryString.parse(document.location.search);
        this.qs = q["qs"] ? q["qs"] as string : null;
    }

    private renderSearchBox(playerId: string, attach: FileGetDto) {
        const player = new VideoPlayerSearchApi(playerId);
        return <VideoSearchBox entityId={attach.fileId} player={player} querySearch={this.qs} />;
    }

    public shouldComponentUpdate(nextProps: RenderVideoType, nextState: RenderVideoState) {
        return nextProps.file != this.props.file
            || nextProps.autoplay != this.props.autoplay
            ;
    }

    render() {
        const { file, onSeeking, onSeeked, onEnded, onPlaying, onPause, onProgress, onReady } = this.props;
        const attach = file as FileGetDto;


        if (attach.mimeType.startsWith("video/")) {

            const { playerId, sources, poster } = getVideoProps(attach);

            if (sources.length > 0) {

                const { innerStyles, outerStyles } = getRenderVideoStyles(attach);

                return (
                    <div>
                        <MuiContainer>
                            <div style={outerStyles}>
                                <div className={GlobalClassKeys.videoContainer} style={innerStyles}>
                                    <VideoPlayer
                                        className={GlobalClassKeys.videoPlayer}
                                        id={playerId}
                                        videoOptions={
                                            {
                                                autoplay: false,
                                                //aspectRatio: aspectRatio,
                                                controls: true,
                                                poster: poster,
                                                sources: sources,

                                                controlBar: {
                                                    volumePanel: {
                                                        inline: false,
                                                        volumeControl: {
                                                            vertical: true
                                                        }
                                                    },
                                                }
                                            }
                                        }
                                        onPlayStartError={
                                            () => this.setState({ playing: false })
                                        }
                                        onEnded={
                                            (player) => {
                                                this.setState({ playing: false });
                                                onEnded && onEnded(player);
                                            }
                                        }
                                        onPlaying={
                                            (player) => {
                                                stopAnothersVideoPlayers(playerId);
                                                stopAnothersYoutubes(null);
                                                onPlaying && onPlaying(player);
                                            }
                                        }
                                        onPause={onPause}
                                        onSeeking={onSeeking}
                                        onSeeked={onSeeked}
                                        onProgress={onProgress}
                                        onReady={onReady}
                                    />
                                </div>
                            </div>
                        </MuiContainer>

                        {
                            attach != null && attach.mediaAsset != null && attach.mediaAsset.hasSubtitle && this.qs && this.renderSearchBox(playerId, attach)
                        }
                    </div>
                );
            }

            return <RenderVideoWaitingEncode attach={attach} />;
        }

        return null;
    };
}

export default RenderVideoFile;